export const MIN_COLUMN_FRACTION = 0.05;

const round3 = (n: number) => Math.round(n * 1000) / 1000;
const sum = (xs: number[]) => xs.reduce((a, b) => a + b, 0);

export function equalWidths(n: number): number[] {
  return Array.from({ length: Math.max(1, n) }, () => 1);
}

export function toPercentages(widths: number[]): number[] {
  const total = sum(widths);
  if (!(total > 0)) return widths.map(() => 100 / widths.length);
  return widths.map((w) => (w / total) * 100);
}

export function isUniform(widths: number[]): boolean {
  const first = widths[0] ?? 0;
  return widths.every((w) => Math.abs(w - first) < 1e-9);
}

/**
 * Move the boundary between column `boundary` and `boundary + 1` by `deltaFraction` of the table width.
 * Only those two columns change; the total stays the same; neither drops below `minFraction` of the total.
 */
export function resizeColumns(
  widths: number[],
  boundary: number,
  deltaFraction: number,
  minFraction = MIN_COLUMN_FRACTION,
): number[] {
  const out = [...widths];
  const a = widths[boundary];
  const b = widths[boundary + 1];
  if (a === undefined || b === undefined || boundary < 0 || !Number.isFinite(deltaFraction)) return out;
  const total = sum(widths);
  const min = minFraction * total;
  if (a + b <= 2 * min) return out;
  const delta = Math.min(Math.max(deltaFraction * total, min - a), b - min);
  out[boundary] = round3(a + delta);
  out[boundary + 1] = round3(b - delta);
  return out;
}
